import apiClient from "@toothfairy/shared-api/apiClient";
import secureRequest from "@toothfairy/shared-api/secureAPI";
import envConfig from "../../../envConfig";
import AppAuth from "@toothfairy/shared-ui/AppAuthScreen";

const storeSecret = async ({ workspaceid, id, passwordSecretValue, suffix }) => {
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/secrets/store`;
  const payload = await AppAuth.getCurrentSession();
  const passwordSecretName = suffix
    ? `${workspaceid}/${id}/${suffix}`
    : `${workspaceid}/${id}`;
  return secureRequest(
    apiClient.apiClient,
    "POST",
    url,
    null,
    {
      passwordSecretName,
      passwordSecretValue,
    },
    true,
    null,
    payload
  );
};

const updateSecret = async ({ workspaceid, id, passwordSecretValue, suffix }) => {
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/secrets/update`;
  const payload = await AppAuth.getCurrentSession();
  const passwordSecretName = suffix
    ? `${workspaceid}/${id}/${suffix}`
    : `${workspaceid}/${id}`;
  return secureRequest(
    apiClient.apiClient,
    "PUT",
    url,
    null,
    {
      passwordSecretName,
      passwordSecretValue,
    },
    true,
    null,
    payload
  );
};

const deleteSecret = async ({ workspaceid, id }) => {
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/secrets/delete?id=${id}&workspaceid=${workspaceid}`;
  const payload = await AppAuth.getCurrentSession();
  return secureRequest(
    apiClient.apiClient,
    "DELETE",
    url,
    null,
    null,
    true,
    null,
    payload
  );
};

export default {
  storeSecret,
  updateSecret,
  deleteSecret,
};
